import type { CSSProperties } from "react";
import { LegalPage, LegalSection } from "../components/LegalPage";

const listStyle: CSSProperties = { margin: 0, paddingLeft: 22, display: "flex", flexDirection: "column", gap: 8 };

export default function Privacidad() {
  return (
    <LegalPage title="Política de Privacidad" updated="Junio 2026">
      <LegalSection title="¿Quiénes somos?">
        <p style={{ margin: 0 }}>
          PzicoDosis es una plataforma digital de psicología fundada en México, dedicada a acercar
          herramientas de salud mental a toda LATAM.
        </p>
        <p style={{ margin: "12px 0 0" }}>
          Contacto: <a href="mailto:psicodosis2024@gmail.com" style={{ color: "#C49A8A" }}>psicodosis2024@gmail.com</a>
        </p>
      </LegalSection>

      <LegalSection title="¿Qué información recopilamos?">
        <ul style={listStyle}>
          <li>Nombre y correo electrónico (al registrarse con Google)</li>
          <li>Foto de perfil (proporcionada por Google)</li>
          <li>Participación en foros y comunidad</li>
          <li>Guías descargadas</li>
        </ul>
      </LegalSection>

      <LegalSection title="¿Para qué usamos tu información?">
        <ul style={listStyle}>
          <li>Personalizar tu experiencia en la plataforma</li>
          <li>Enviarte guías psicoeducativas solicitadas</li>
          <li>Mejorar nuestros servicios</li>
          <li>Comunicarnos contigo sobre tu cuenta</li>
        </ul>
      </LegalSection>

      <LegalSection title="¿Compartimos tu información?">
        <p style={{ margin: 0 }}>
          No vendemos ni compartimos tu información personal con terceros. Solo usamos servicios de
          confianza como Google (autenticación) y Cloudflare (infraestructura).
        </p>
      </LegalSection>

      <LegalSection title="Tus derechos">
        <p style={{ margin: 0 }}>
          Puedes solicitar la eliminación de tu cuenta y datos en cualquier momento escribiendo a{" "}
          <a href="mailto:psicodosis2024@gmail.com" style={{ color: "#C49A8A" }}>psicodosis2024@gmail.com</a>.
        </p>
      </LegalSection>

      <LegalSection title="Cookies">
        <p style={{ margin: 0 }}>
          Usamos cookies únicamente para mantener tu sesión activa. No usamos cookies de rastreo
          publicitario.
        </p>
      </LegalSection>

      <LegalSection title="Cambios a esta política">
        <p style={{ margin: 0 }}>
          Notificaremos cualquier cambio importante por email.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
